import api from "../api/axios";

export const processUniqueClients = async (file1, file2) => {
  const formData = new FormData();
  if (file1) formData.append("file1", file1);
  if (file2) formData.append("file2", file2);

  try {
    const response = await api.post("/files/process-unique-clients", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
      responseType: "blob",
    });
    return response.data;
  } catch (error) {
    if (error.response && error.response.data instanceof Blob) {
      const text = await error.response.data.text();
      try {
        const data = JSON.parse(text);
        error.message = data.message || error.message;
      } catch (e) {
        // Not JSON, keep original error.message
      }
    } else if (error.response?.data?.message) {
      error.message = error.response.data.message;
    }
    throw error;
  }
};

export const processUberFile = async (file, memoFilter) => {
  const formData = new FormData();
  formData.append("file", file);
  if (memoFilter && memoFilter !== "All") {
    formData.append("memoFilter", memoFilter);
  }

  const response = await api.post("/files/process-uber-file", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  return response.data;
};

export const processRightRideJsonFile = async (file) => {
  const formData = new FormData();
  formData.append("file", file);

  const response = await api.post("/files/process-rightride-file", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
    responseType: "blob",
  });
  return response.data;
};

export const processClaimFiles = async (file1, file2) => {
  const formData = new FormData();
  if (file1) formData.append("file1", file1);
  if (file2) {
    if (Array.isArray(file2)) {
      file2.forEach((file) => formData.append("file2", file));
    } else {
      formData.append("file2", file2);
    }
  }

  try {
    const response = await api.post("/files/process-claim-files", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
      responseType: "blob",
    });
    return response.data;
  } catch (error) {
    if (error.response && error.response.data instanceof Blob) {
      const text = await error.response.data.text();
      try {
        const data = JSON.parse(text);
        error.message = data.message || error.message;
      } catch (e) {
        // Not JSON, keep original error.message
      }
    } else if (error.response?.data?.message) {
      error.message = error.response.data.message;
    }
    throw error;
  }
};
